import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { UtilityService } from './core/services/UtilityService/UtilitiesService';
import { OidcSecurityService } from 'angular-auth-oidc-client';
// Time threshold
const WARNING_TIME_THRESHOLD = 240000; // 4 mins (240000 milliseconds)
const INACTIVE_TIME_THRESHOLD = 300000; // 5 mins (300000 milliseconds)

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  lastActivityTime: number;
  showWarning: boolean;

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private utilityService: UtilityService,
    private oidcSecurityService: OidcSecurityService,
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();

    // Initialize activity dectection
    // this.initActivityDetection();
      
  }

  // Initialize activity dectection
  initActivityDetection() {
    setInterval(() => {
      const timeDiff = Date.now() - this.lastActivityTime;
      if (timeDiff > INACTIVE_TIME_THRESHOLD) { // Log out users after 5 mins of inactive
        this.logout()
        return;
      }
      if (timeDiff > WARNING_TIME_THRESHOLD && !this.showWarning) { // Show warning popup after 4 mins of inactive 
        this.showWarning = true;
        this.showInactiveConfirmModal()
      } else if (timeDiff <= WARNING_TIME_THRESHOLD && this.showWarning) {
        this.showWarning = false;
      }
    }, 1000); // check every second
  }

  // Reset activity
  resetActivity() {
    this.showWarning = false;
    this.lastActivityTime = Date.now();
  }

  // Check if there's no mouse movement or keyboard clicks
  @HostListener('document:mousemove')
  @HostListener('document:keypress')
  onUserActivity() {
    this.lastActivityTime = Date.now();
  }
  
  // Show Inactivity message modal
  async showInactiveConfirmModal() {
    const result = await this.utilityService.confirmSignOutPopup('Your session expired, please click "Continue" to log in.');
    if (result) {
      // If user clicks continue, reset timeout
      this.resetActivity()
    } else {
      // If user clicks signout, log user out
      this.logout()
    }
  }

  // Logout
  logout() {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe((result) => console.log(result));
  }

}
